import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { CaGuide } from '../../../core';

import { TranslationKeyMap } from './guide-card.component.i18n';

@Component({
    selector: 'cmps-ca-guide-card',
    templateUrl: './guide-card.component.html',
    host: {
        class: 'cmps-ca-guide-card',
    },
})
export class GuideCardComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    @Input() guide: CaGuide;
    @Input() picked: boolean;
    @Input() reasonText: string | null = null;

    /** @private */
    _reasonExpanded = false;

    constructor(private readonly _cdr: ChangeDetectorRef) {}

    /** @private */
    _toggleReason(): void {
        this._reasonExpanded = !this._reasonExpanded;
        this._cdr.detectChanges();
    }
}
